export const getListaPastas = state => {
    return state.listaPastas;
};

export const getListaArquivos = state => {
    return state.listaArquivos;
};